document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-countdown-banner]').forEach(function (section) {
    var countdown = section.querySelector('[data-countdown]');
    var endDateStr = section.dataset.endDate;

    if (!endDateStr) {
      if (countdown) countdown.classList.add('countdown--hidden');
      return;
    }

    var endDate = new Date(endDateStr);
    if (isNaN(endDate.getTime())) {
      if (countdown) countdown.classList.add('countdown--hidden');
      return;
    }

    var daysEl    = section.querySelector('[data-unit="days"]');
    var hoursEl   = section.querySelector('[data-unit="hours"]');
    var minutesEl = section.querySelector('[data-unit="minutes"]');
    var secondsEl = section.querySelector('[data-unit="seconds"]');

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function update() {
      var diff = endDate - Date.now();
      if (diff <= 0) {
        section.style.display = 'none';
        clearInterval(interval);
        return;
      }

      var days    = Math.floor(diff / 86400000);
      var hours   = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      daysEl.textContent    = pad(days);
      hoursEl.textContent   = pad(hours);
      minutesEl.textContent = pad(minutes);

      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    update();
    var interval = setInterval(update, 1000);
  });
});
